import {defineMessages} from "@project/i18n";

export const materialDescriptionFieldLabelIds = {
  language: "fields.material.description.language",
  text: "fields.material.description.text",
} as const;

export const materialDescriptionFieldMessages = defineMessages({
  language: {
    id: "fields.material.description.language",
    defaultMessage: "Language",
    description: "Material description language label",
  },
  text: {
    id: "fields.material.description.text",
    defaultMessage: "Description",
    description: "Material description text label",
  },
});
